import { AxiosRequestConfig, AxiosResponse } from 'axios';

export interface RefreshWaitingQueueItem {
	resolve: (accessToken: string) => unknown;
	reject: (error: unknown) => unknown;
	request: AxiosRequestConfig;
}

/**
 * When one refresh-token call is in progress, the rest wait for it to resolve
 * to reuse its response.
 */
export class RefreshWaitingQueue {
	isRefreshing = false;

	refreshWaitingQueue: RefreshWaitingQueueItem[] = [];

	constructor(
		private readonly requestExecutor: (request: AxiosRequestConfig) => Promise<AxiosResponse | any>,
	) {}

	push(request: AxiosRequestConfig) {
		return new Promise((resolve, reject) => {
			this.refreshWaitingQueue.push({ resolve, reject, request });
		})
			.then((token) => {
				const headers = request.headers || {};
				headers.Authorization = `Bearer ${token}`;
				request.headers = headers;

				return this.requestExecutor(request);
			})
			.catch((err) => Promise.reject(err));
	}

	resolveQueued(accessToken: string) {
		this.refreshWaitingQueue.forEach((promise) => {
			promise.resolve(accessToken);
		});
		this.refreshWaitingQueue = [];
	}

	rejectQueued(error: any) {
		this.refreshWaitingQueue.forEach((promise, index) => {
			promise.reject({ ...error, config: { ...error?.config, queueIndex: index } });
		});

		this.refreshWaitingQueue = [];
	}

	get pendingCount() {
		return this.refreshWaitingQueue.length;
	}
}
